module.exports = __webpack_public_path__ + "img/9788974744427.15d9553d.jpg";